const TRUE_OPTIONS = new Set(['speaker_labels', 'multichannel', 'disfluencies']);
const ARRAY_OPTIONS = new Set(['keyterms_prompt', 'custom_spelling']);

export const getInitialProviderOptionValue = (option: string): string => {
  if (TRUE_OPTIONS.has(option)) {
    return 'true';
  }
  if (ARRAY_OPTIONS.has(option)) {
    return '[]';
  }
  if (option === 'speaker_options') {
    return '{}';
  }
  if (option === 'speakers_expected') {
    return '2';
  }
  if (option === 'language_code') {
    return '"en_us"';
  }
  if (option === 'speech_model') {
    return '"universal-3-5-pro"';
  }
  if (option === 'speech_models') {
    return '["universal-3-5-pro","universal-2"]';
  }
  return '""';
};
